<template src="./LogIn.html"/>
<style lang="scss" scoped src="./LogIn.scss"/>
<script>

import {SfHeading, SfAlert, SfButton, SfInput, SfLoader} from '@storefront-ui/vue';
import OrkRecaptcha from "@/components/Ork/OrkRecaptcha";
import Api from "@/api/Api";

export default {
  name: "LogInGpNet",
  components: {
    OrkRecaptcha,
    SfHeading,
    SfAlert,
    SfInput,
    SfButton,
    SfLoader,
  },
  data() {
    return {
      loading: false,
      error: null,
      valid: false,
      submitted: false,
      password: null,
      passwordBlur: true,
      email: null,
      emailBlur: true,
      gpnetId: null,
      gpNetBlur: true
    }
  },
  watch: {
    isLogIn() {
      this.gpnetId = ""
      this.email = ""
      this.password = ""
    },
  },
  methods: {
    executeRecaptcha() {
      this.$refs.recaptchaGpnetLogin.execute()
    },
    validate() {
      this.emailBlur = false;
      if (
          this.validEmail(this.email) &&
          this.validGpNet(this.gpnetId)
      ) {
        this.valid = true;
      }
    },
    validEmail(email) {
      const regex = /(.+)@(.+){2,}\.(.+){2,}/
      const hasWhiteSpace = /\s/;
      if (regex.test(email.toLowerCase()) && !hasWhiteSpace.test(email.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },
    validGpNet(gpnetId) {
      if (gpnetId) {
        return gpnetId.length === 8;
      }
    },


    submitGpnetLoginForm(token) {
      const onComplete = () => {
        if (!this.error || this.error.status === 200) {
          this.loading = false;
        } else {
          this.loading = false;
        }
      };

      const onError = (e) => {
        this.error = e;
        this.loading = false;
      };
      this.validate()
      if (this.valid) {
        this.loading = true;
        this.$emit('submit', {
          form: {email: this.email, password: this.password, gpnetId: this.gpnetId, recaptchaData: token},
          onComplete,
          onError
        });

      }
    },
    /*
        handleLogin() {
          this.$emit('handleLogin', {email: this.email, password: this.password})
          this.loading = true
          Api.account.login({email: this.email, password: this.password})
              .then((data) => {
                this.$store.dispatch('loginCustomer', data);
                this.$store.dispatch('toggleWelcomeModal', {
                  open: true,
                  customer: data
                });
                this.$store.dispatch('toggleLoginModal',{open:false});

              })
              .catch((e) => {
                this.$store.dispatch('sendNotification', {type: 'danger', message: 'login error', icon: 'error'});
                this.error = e
              })
              .finally(() => {
                this.loading = false;
              })
        },
    */
  }
}
</script>


